import { IWatchContext, IFilterValues } from './watchContext';

export enum WatchActionTypes {
	SET_WATCHES = 'SET_WATCHES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	TOGGLE_IS_ACTIVE = 'TOGGLE_IS_ACTIVE',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_FULL_INFO = 'SET_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetWatch {
	type: WatchActionTypes.SET_WATCHES;
	payload: {
		watches: IWatchContext['watches'];
		typeOfModalWindow: IWatchContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: WatchActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IWatchContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: WatchActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IWatchContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: WatchActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IWatchContext['IDSelectedRestaurant'];
	};
}

interface IToggleIsActive {
	type: WatchActionTypes.TOGGLE_IS_ACTIVE;
}

interface IResetSelectedControls {
	type: WatchActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: WatchActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IWatchContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: WatchActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IWatchContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: WatchActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IWatchContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: WatchActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IWatchContext['IDForDeletion'];
		typeOfModalWindow: IWatchContext['typeOfModalWindow'];
	};
}

interface ISetIDForFullInfo {
	type: WatchActionTypes.SET_ID_FOR_FULL_INFO;
	payload: {
		IDForFullInfo: IWatchContext['IDForFullInfo'];
	};
}

interface IChangeTypeOfModalWindow {
	type: WatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IWatchContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: WatchActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TWatchAction =
	| ISetWatch
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| IToggleIsActive
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForFullInfo
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
